import moment from "moment";
import "moment-timezone";
import "moment/locale/de";
import "moment/locale/fr";

window.moment = moment;
